import { Stack, styled } from "@mui/material";
import {
  FlexBox,
  type FlexBoxProps,
} from "@/components/baseComponents/FlexBox";

export const StyledBaseLayout = styled(Stack)(() => ({
  minHeight: "100dvh",
}));

export const StyledBaseMain = styled((props: FlexBoxProps) => (
  <FlexBox component="main" {...props} />
))(() => ({
  alignItems: "flex-start",
  flex: "1",
  zIndex: "1",
}));
